import { render, staticRenderFns } from "./tc-tabs.vue?vue&type=template&id=5b11de04&scoped=true&"
import script from "./tc-tabs.vue?vue&type=script&lang=js&"
export * from "./tc-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b11de04",
  null
  
)

export default component.exports